import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { DatepickerModule } from '@bcef/ia-components/datepicker';
import { PanelModule } from '@bcef/ia-components/panel';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';

import { SuccessionFacade } from '@features/succession/succession.facade';
import { InvalidControlScrollDirective } from '@shared/directives/invalid-control-scroll.directive';

import { DeceasedMoreInformationFacade } from './deceased-more-information.facade';
import { DocumentRowComponent } from './document/document-row.component';

@DataLayered('dataLayer.deceasedMoreInformation')
@Component({
  selector: 'ia-succession-deceased-more-information',
  templateUrl: './deceased-more-information.component.html',
  imports: [
    AsyncPipe,
    ButtonModule,
    DatepickerModule,
    ReactiveFormsModule,
    TranslateModule,
    DocumentRowComponent,
    InvalidControlScrollDirective,
    PanelModule,
    RadioButtonModule,
  ],
  standalone: true,
})
export class DeceasedMoreInformationComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-12.5 sm:tw-mx-24';

  public readonly successionFacade = inject(SuccessionFacade);

  public readonly deceasedMoreInformationFacade = inject(DeceasedMoreInformationFacade);
}
